import axiosInstance from "shared/services/api/axiosInstance";

/**
 * Dashboard context for chat: server runs execute for each attachment and returns result payloads (not query DSL).
 * Uses boards router so it always loads with the same middleware as other board APIs.
 */
export async function postChatContext({ message, attachments }) {
  const response = await axiosInstance.post("/boards/chat/context", {
    message,
    attachments,
  });
  return response.data;
}
